module.exports = __webpack_public_path__ + "static/media/iconcoins.8e4cb2ee.png";